
import React from "react";

// renders words prefixed with ":" in the accent colour, e.g. "News & :Matches"
function Highlight({ text }: { text: string; }) {
    return (<>
        {(text ?? "").split(/(:[A-Za-z]+)/).map((part, i) => part.startsWith(":")
            ? (<strong key={i}>{part.substring(1)}</strong>)
            : (<React.Fragment key={i}>{part}</React.Fragment>))}
    </>);
}

export default Highlight;
